export const FooterComponent = () => {
    return (
        <div className="footer">
            <h6>Michelle Chan © 2024. All Rights Reserved.</h6>
        </div>
    )
}

export default FooterComponent;